import { DAYLIGHT_MODE_BANDS, type DaylightModeBand } from "@shared/daylightMode";

/**
 * Landscape scenes live in client/public/sales-ambience/ (copied to dist/public on build).
 * Set on documentElement as --ambience-scene-image from DaylightModeContext — not in CSS url(),
 * so Vite/Lightning CSS does not try to rewrite asset paths during production builds.
 */
export const SALES_AMBIENCE_SCENE_PATHS: Record<DaylightModeBand, string> = {
  dawn: "/sales-ambience/dawn.svg",
  morning: "/sales-ambience/morning.svg",
  noon: "/sales-ambience/noon.svg",
  afternoon: "/sales-ambience/afternoon.svg",
  dusk: "/sales-ambience/dusk.svg",
  night: "/sales-ambience/night.svg",
};

export function salesAmbienceSceneImageCss(band: DaylightModeBand): string {
  return `url("${SALES_AMBIENCE_SCENE_PATHS[band]}")`;
}

/** Verify every band has a public scene file path (build/deploy checklist). */
export const SALES_AMBIENCE_SCENE_PATH_LIST = DAYLIGHT_MODE_BANDS.map(
  (band) => SALES_AMBIENCE_SCENE_PATHS[band],
);
